import React, { useState, useCallback, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import CommonComponentForQuestionsAndOption from '../Common/FeedbackGridRow';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/styles.css';
import '../../assets/css/login.css';
var Modal = require('react-bootstrap-modal');
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function SSSFeedback(props) {
  document.title = props.title;
  const navigate = useNavigate();

  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userDetailsLog'));
  var selectedStudentClassSemester = localStorage.getItem('selectedStudentClassSemester');
  const [modelPopupStatus, setModelPopupStatus] = useState(false);
  const [componentLodignState, setComponentLodignState] = useState(false);
  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [courseName, setCourseName] = useState(userLoginDetails.courseName);
  const [allSSSQuestionsArray, setSSSQuestionsArray] = useState([]);
  const [allSSSStudentAnswersArray, setSSSStudentAnswersArray] = useState([]);

  useEffect(() => {
    getAllSSSQuestions();
  }, []);

  function clickBackToMain() {
    navigate('/StudentDashboard');
  }

  function getAllSSSQuestions() {
    setComponentLodignState(true);
    axios.post(config.API_URL + 'getSSSQuestion', {
      userId: userLoginDetails.LoginUserId
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setSSSQuestionsArray(response.data.data);
        } else {
          setSSSQuestionsArray([]);
        }
        setComponentLodignState(false);
      }
    }).catch(function (error) {
      toast(error);
      setComponentLodignState(false);
    });
  }

  const onItemClick = useCallback(event => {
    let Obj = {
      question_id: event.target.getAttribute('questionid'),
      subject_id: "",
      teacher_id: "",
      answer: event.target.getAttribute('questionanswer'),
      description: ""
    }
    if (allSSSStudentAnswersArray.length == 0) {
      allSSSStudentAnswersArray.push(Obj)
      setSSSStudentAnswersArray(allSSSStudentAnswersArray);
    } else {
      let checkNewPushBit = true;
      let obj = allSSSStudentAnswersArray.find((o, i) => {
        if (o.question_id === event.target.getAttribute('questionid')) {
          allSSSStudentAnswersArray[i] = Obj;
          checkNewPushBit = false;
        }
      });
      if (checkNewPushBit) {
        allSSSStudentAnswersArray.push(Obj)
      }
      setSSSStudentAnswersArray(allSSSStudentAnswersArray);
    }
    var element = document.getElementById("studentInfra" + event.target.getAttribute('questionid'));
    element.classList.remove("error");
    // var target = event.target;
    // var parent = target.parentElement.parentElement;//parent of "target"
  }, [allSSSQuestionsArray]);


  function onSubmitSSSClick() {
    if (allSSSStudentAnswersArray.length == allSSSQuestionsArray.length) {
      axios.post(config.API_URL + 'submitAllStudentFeedback', {
        ragisterUserId: userLoginDetails.mstr_auto_id,
        submittedFeedbackType: "SSS",
        userRole: userLoginDetails.role_master_auto_id,
        currentAcademicYear: userLoginDetails.mstr_student_teacher_academic_year,
        classSemester: selectedStudentClassSemester,
        answersArray: allSSSStudentAnswersArray
      }, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      }).then(function (response) {
        if (response.data.status.status == 1) {
          toast.success(response.data.status.message);
          setModelPopupStatus(true);
        }
      }).catch(function (error) {
        toast.error(error);
      });
    } else {
      allSSSQuestionsArray.map((questions, index) => {
        let checkValidation = allSSSStudentAnswersArray.find(o => o.question_id === questions.mafq_auto_id);
        if (!checkValidation) {
          var element = document.getElementById("studentInfra" + questions.mafq_auto_id);
          element.classList.add("error");
        }
        console.log("checkValidation", checkValidation);
      });
      toast.error("All student satisfaction survey questions are compulsory.");
    }
  }

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/');
  }

  let saveAndClose = () => {
    setModelPopupStatus(false);
    navigate('/StudentDashboard');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (
    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'>
            <div className="col-md-12" >
              <div className='logout-strip'>
                <div className='link-holder'>
                  <a className="btn-link" type="button">Welcome {userLoginDetails.mstr_student_teacher_first_name}&nbsp;{userLoginDetails.mstr_student_teacher_last_name}&nbsp;[&nbsp;{userLoginDetails.courseName}&nbsp;]</a>
                  <span className='line-divider'></span>
                  <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
                </div>
              </div>
              <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
              <div className='feedback-title' >Student Satisfaction Survey</div>
            </div>
          </div>
          <div className='feedbackFor'><a href='#' className='backToMain' onClick={clickBackToMain}><i className='fa fa-arrow-left'
            style={{ marginRight: '5px' }}></i>Back to Dashboard</a><span
              className='divider'>|</span><strong>Year:</strong>{userLoginDetails.mstr_student_teacher_academic_year}<span className='divider'>|</span><strong>
              Semester:</strong>{selectedStudentClassSemester} <span className='divider'>|</span> <strong>Program:</strong> {courseName}
            <span className='divider'>|</span> <strong>Section:</strong> {userLoginDetails.mstr_section_name}
          </div>
        </section>

        {componentLodignState == true ?
          <div class="loader-bg">
            <h3>Please Wait...</h3>
            <div class="loader">
              <span></span>
            </div>
          </div>
          :
          <section className='section-survey section-surveyStudentInfrastructure'>
            <div className="row">
              <div className="col-md-12">
                <div className='info info-white'>Fields marked with <em>*</em> are mandatory</div>
                <div className='questionnnaire-wrapper'>
                  <div className='grid-row row-header sticky'>
                    <div className='column col-srno'>#</div>
                    <div className='column col-question'><div className='column-content'> &nbsp;</div></div>
                    <div className='column col-grade'>Strongly Agree</div>
                    <div className='column col-grade'>Agree</div>
                    <div className='column col-grade'>Neutral</div>
                    <div className='column col-grade'>Disagree</div>
                    <div className='column col-grade'>Strongly Disagree</div>
                  </div>
                  {
                    allSSSQuestionsArray.length >= 1 ?
                      allSSSQuestionsArray.map((questions, index) => (
                        <CommonComponentForQuestionsAndOption term={questions} onItemClick={onItemClick} srNo={index + 1} />
                      ))
                      : null
                  }
                </div>
              </div>
              <div className='col-md-12'>
                <button type="button" className="btn btn-primary btn-submitForm btn-block" onClick={onSubmitSSSClick}>Submit</button>
              </div>
            </div>
          </section>
        }
        <section className='section-footer'>
          <div className='row'>
            <div className='footer'>
              <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
              <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
            </div>
          </div>
        </section>

      </div>
      <ToastContainer />
      <Modal
        show={modelPopupStatus}
        backdrop="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Body>
          <div className="font-robo">
            <div className="">
              <div className="card card-1 " style={{ boxShadow: 'none' }}>
                {/* <div className="logo-holder">
                  <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                  <div className='feedback-title' >Feedback System</div>
                </div> */}
                <div className="card-body card-thankyou" style={{ padding: '28px 28px', textAlign: 'center' }}>
                  <center>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                      <circle className="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                      <polyline className="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                    </svg>
                  </center>
                  <div className='message-submitThankyou'>
                    <h3>Student satisfaction survey feedback submitted successfully.<br />
                      Thank you for your valuable time.</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <center>
            <button className='btn btn-primary btn-submitForm' style={{ display: 'block' }} onClick={saveAndClose}>
              Back to Main Page
            </button>
          </center>
        </Modal.Footer>
      </Modal>
    </div>
  )
}